/**
 * 체온 데이터를 포맷팅하는 유틸 함수
 * tempMin과 tempMax를 조합하여 temp 필드를 생성
 * - 둘 다 있는 경우: "tempMin/tempMax" 형식
 * - 하나만 있는 경우: 해당 값만 사용
 * - 둘 다 없는 경우: 원본 객체 반환
 */

interface AttendItem {
  tempMin?: number | string;
  tempMax?: number | string;
  [key: string]: any;
}

export const addTemperatureField = <T extends AttendItem>(item: T): T & { temp?: string | number } => {
  if (item.tempMin && item.tempMax) {
    return { ...item, temp: `${item.tempMin} / ${item.tempMax}` };
  }
  if (item.tempMin) {
    return { ...item, temp: item.tempMin };
  }
  if (item.tempMax) {
    return { ...item, temp: item.tempMax };
  }
  return item;
};

export const formatAttendListWithTemperature = <T extends AttendItem>(attendList: T[] | undefined | null): (T & { temp?: string | number })[] => {
  if (!attendList) {
    return [];
  }
  return attendList.map(addTemperatureField);
};
